<div class="table-container" infiniteScroll #scrollOne
  [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" [scrollWindow]="false">
  <table class="table">
    <thead class="thead">
      <tr>
        <th *ngFor="let t of title" class="">{{t}}</th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr class="" *ngFor="let item of data; index as i">
        <td class="">
          {{item.name}}
        </td>
        <td *ngFor="let q of item.quantity" class="">
          {{q || '-'}}
        </td>
        <td class="total">
          {{item.total}}
        </td>
      </tr>
    </tbody>
    <tfoot class="tfoot">
      <tr class="">
        <th>
          TOTAL
        </th>
        <th class="" *ngFor="let item of totals">
          {{item || '-'}}
        </th>
      </tr>
    </tfoot>
  </table>
</div>